import React from "react";
import { useNavigate } from "react-router-dom";
import { WarningCircle, CaretRight } from "@phosphor-icons/react";
import { formatCurrency } from "@/lib/format";
import { Card } from "@/components/ui/card";

export default function BudgetOverrunAlert({ jobs }) {
  const navigate = useNavigate();
  const overruns = (jobs || [])
    .filter((j) => Number(j.budget_allocated) > 0 && Number(j.budget_spent) > Number(j.budget_allocated))
    .map((j) => ({ ...j, over: Number(j.budget_spent) - Number(j.budget_allocated) }))
    .sort((a, b) => b.over - a.over);

  if (overruns.length === 0) return null;

  return (
    <Card className="border-red-200 bg-red-50/60 shadow-none" data-testid="budget-overrun-alert">
      <div className="flex items-center gap-2 px-5 py-3.5 border-b border-red-100">
        <WarningCircle className="h-5 w-5 text-red-600" weight="fill" />
        <h3 className="font-semibold text-red-900">
          Budget Overrun — {overruns.length} job{overruns.length > 1 ? "s" : ""} over allocated budget
        </h3>
      </div>
      <ul className="divide-y divide-red-100">
        {overruns.map((j) => (
          <li key={j.id}>
            <button
              onClick={() => navigate(`/jobs/${j.id}`)}
              className="w-full flex items-center justify-between gap-3 px-5 py-3 text-left hover:bg-red-100/50 transition-colors"
              data-testid={`overrun-row-${j.code}`}
            >
              <span className="min-w-0">
                <span className="font-mono text-sm font-medium text-red-700">{j.code}</span>
                <span className="text-sm text-slate-700"> · {j.client_name} · {j.job_name}</span>
              </span>
              <span className="flex items-center gap-3 shrink-0 text-sm">
                <span className="text-slate-500 hidden sm:inline">
                  {formatCurrency(j.budget_spent)} of {formatCurrency(j.budget_allocated)}
                </span>
                <span className="font-semibold text-red-700">
                  +{formatCurrency(j.over)} ({j.variance_pct > 0 ? "+" : ""}{j.variance_pct}%)
                </span>
                <CaretRight className="h-4 w-4 text-red-400" />
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Card>
  );
}
